import { SkeletonProps } from './skeleton.type'

import styles from './skeleton.module.css'

export const Skeleton = ({
  isActive = true,
  height,
  width = '100%',
  className = '',
  isCircle = false,
}: SkeletonProps) => {
  if (isActive) {
    return (
      <div
        className={`${styles['shimmer-placeholder']} ${isCircle ? styles.circle : ''} ${className || ''}`}
        style={{
          height,
          width,
        }}
      />
    )
  }

  return null
}
